/** @format */

// eslint-disable-next-line no-unused-vars
export const getAssociationData = ({ dataSet, processValue }) => {
  return {
    body: []
  };
};
